<template>
  <div>
    <v-snackbar
      variant="text"
      :timeout="snackbarStore.duration"
      v-model="snackbarStore.active"
    >
      <template v-slot:activator>
        <div class="snackbar-container"></div>
      </template>
      <template v-slot:text>
        <div class="text-container" :style="{ 'color': textColor, 'border': borderProperties, 'background-color': backgroundColor }">
          <v-row no-gutters>
            <v-col cols="1">
              <v-icon>{{ snackbarStore.icon }}</v-icon>
            </v-col>
            <v-col cols="10">
              <span>{{ snackbarStore.content }}</span>
            </v-col>
            <v-col align="right">
              <v-icon @click="closeSnackbar()">mdi mdi-close</v-icon>
            </v-col>
          </v-row>
        </div>
      </template>
    </v-snackbar>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useSnackbarStore } from '../stores/snackbar'
import Helpers from './helper.js'

const snackbarStore = useSnackbarStore()

const textColor = computed(() => snackbarStore.color)
const borderProperties = computed(() => `1px solid ${snackbarStore.color}`)
const backgroundColor = computed(() => snackbarStore.bgColor)

const closeSnackbar = () => {
  Helpers.closeSnackbar()
}
</script>

<style scoped>
.text-container {
  padding: 10px;
  border-radius: 10px;
}
</style>
